import Profile from '../../components/Profile';

export default function SuperAdminProfile() {
  return <Profile role="super_admin" />;
}